import { LicenseManagerService, SPHLoggedInUser, SPHLicense, SPHApplication } from './../../shared/shared';
import { ViewController, ToastController, NavParams } from 'ionic-angular';
import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'reset-license.component',
  templateUrl: 'reset-license.component.html'
})

export class ResetLicenseComponent {
  private canReset = false;

  private _licenses: SPHLicense[];
  @Input() set licenses(licenses: SPHLicense[]) {
    this._licenses = licenses;
  }

  get licenses(): SPHLicense[] {
    return this._licenses;
  }

  private _user: SPHLoggedInUser;
  @Input() set user(user: SPHLoggedInUser) {
    this._user = user;
  }

  get user(): SPHLoggedInUser {
    return this._user;
  }

  private applicationsToReset: SPHApplication[] = [];
  private applications: SPHApplication = null;

  constructor(private navParams: NavParams, private viewController: ViewController, private licenseManager: LicenseManagerService, private toastController: ToastController) {
    this.user = navParams.get('user');
    this.applications = navParams.get('applications');
    this.licenses = navParams.get('licenses');
  }

  public didTapAbort() {
    this.viewController.dismiss();
  }

  public resetLicense() {
    if (this.licenses.length > 1) {
      this.resetLicenses();
    } else {
      this.licenseManager.resetLicense(this.licenses[0].id, this.applicationsToReset, this.user.jwt).subscribe((response) => {
        const toast = this.toastController.create({message: 'Lizenz-Zuweisung gelöscht! ', duration: 3000});
        toast.present();
        this.viewController.dismiss();
      }, this.licenseManager.handleHttpError('Fehler beim Löschen der Lizenz-Zuweisung.'));
    }
  }

  public resetLicenses() {
    const observables = this.licenses.map((license) => {
      return this.licenseManager.resetLicense(license.id, this.applicationsToReset, this.user.jwt);
    });
    Observable.forkJoin(observables).subscribe((results) => {
      const toast = this.toastController.create({
        message: results.length + (results.length > 1 ? ' Zuweisungen' : ' Zuweisung') + ' gelöscht',
        duration: 3000
      });
      toast.present();
      this.viewController.dismiss();
    }, this.licenseManager.handleHttpError('Fehler beim Löschen der Zuweisung'));
  }

  private shouldSendReset(application: SPHApplication) {
    return this.applicationsToReset.filter((element) => element.id === application.id).length > 0;
  }

  private didTapActivateReset(application: SPHApplication) {
    if (this.shouldSendReset(application)) {
      this.applicationsToReset = this.applicationsToReset.filter((element) => element.id !== application.id);
    } else {
      this.applicationsToReset.push(application);
    }
    this.canReset = this.applicationsToReset.length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/resetLicenseComponent/reset-license.component.ts